import { render } from "./CreateVariationAttributeModal.vue?vue&type=template&id=05a310e5"
import script from "./CreateVariationAttributeModal.vue?vue&type=script&lang=js"
export * from "./CreateVariationAttributeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__